import { render } from "./regionManage.vue?vue&type=template&id=ebd73304&scoped=true"
import script from "./regionManage.vue?vue&type=script&lang=js"
export * from "./regionManage.vue?vue&type=script&lang=js"

import "./regionManage.vue?vue&type=style&index=0&id=ebd73304&lang=scss"
import "./regionManage.vue?vue&type=style&index=1&id=ebd73304&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ebd73304"

export default script